// React and third-party imports
import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import { DatePicker } from "rsuite";

// Local component imports
import MyComponentImportData from "./EllipsisComponentImportData.jsx";

// Helper imports
import TimestampConverter from "../helpers/TimestampConverter.jsx";
import zoneConverter from "../helpers/zoneConverter.jsx";
import {
  convertTo24HourFormatback,
  formatChange,
  convertTo24HourFormat,
  formatTimeTo24Hr,
  convertTo12,
  isEndTimeGreater,
  isValidTimeFormat,
  convertTo24Hour,
  validateNoAlphabets,
} from "../services/timeFormat.js";

// API hooks
import { useClientProjectDetails, useTagDetails } from "../../../Timer/tracker/TimerDataApi.jsx";

// Redux actions
import { setTimerData } from "../../../../../features/timerData/timerDataSlice.js";

// Image imports
import TopArrow from "../../../../../images/icons/top-small-arrow.svg";
import DownArrow from "../../../../../images/icons/bottom-small-arrow.svg";
import Update from "../../../../../images/icons/upate-icon1.png";
import Plus from "../../../../../images/icons/circle-plus.svg";
import { tenantDayKey } from "../../../../../utils/tenantDate";
const CardBodyImportDataCalendar = ({
  item,
  timeFormat,
  refetchTimerData,
  invalidEntryIds = new Set(),
  setInvalidEntryIds,
  onEditedIdChange,
  globalEditedId,
  setGlobalEditedId,
  setIsUpdateLoading,
  selectedEntries, // Lifted state from parent for immediate updates
  setSelectedEntries // Lifted state setter from parent
}) => {
  // ==================== Redux & Hooks ====================
  const dispatch = useDispatch();
  const { appSettings } = useSelector((state) => state.appSettings);
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const timerData = useSelector((state) => state.timerData.timerDataState);
  const { data: clientData = [], isLoading: isLoadingClientProjectDetails } = useClientProjectDetails(token);
  const { data: tagOptions = [], isLoading: isLoadingTagDetails } = useTagDetails(token);

  // ==================== Edit State ====================
  const [editedId, setEditedId] = useState(null);
  const [taskNameEdit, setTaskNameEdit] = useState("");
  const [dateEdit, setDateEdit] = useState(new Date());
  const [dateOldEdit, setDateOldEdit] = useState(null);

  // Time edit state
  const [startTimeEdit, setStartTimeEdit] = useState("");
  const [startTimeTemp, setStartTimeTemp] = useState("");
  const [startTimeEdit24, setStartTimeEdit24] = useState("");
  const [endTimeEdit, setEndTimeEdit] = useState("");
  const [endTimeTemp, setEndTimeTemp] = useState("");
  const [endTimeEdit24, setEndTimeEdit24] = useState("");
  const [uDuration, setUDuration] = useState(null);
  const [uFormatedTime, setUFormatedTime] = useState(0);

  // Project/Client/Sprint edit state
  const [projectNameEdit, setProjectNameEdit] = useState("");
  const [projectIdEdit, setProjectIdEdit] = useState("");
  const [sprintIdEdit, setSprintIdEdit] = useState("");
  const [sprintNameEdit, setSprintNameEdit] = useState("");
  const [clientEdit, setClientEdit] = useState(null);
  const [clientIdEdit, setClientIdEdit] = useState(null);

  // Tag and other edit state
  const [tagIdEdit, setTagIdEdit] = useState(null);
  const [tagEdit, setTagEdit] = useState(null);
  const [billableEdit, setBillableEdit] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // ==================== UI State ====================
  const [projectEditDropdownOpen, setProjectEditDropdownOpen] = useState(false);
  const [tagEditDropdownOpen, setTagEditDropdownOpen] = useState(false);
  const [isTimeInputActive, setIsTimeInputActive] = useState(false);
  const [filter, setFilter] = useState("");
  const [selectedClients, setSelectedClients] = useState(new Set());
  const [selectedProject, setSelectedProject] = useState(null);
  const [tagQuery, setTagQuery] = useState("");

  // Error states
  const [uEndTimeError, setUEndTimeError] = useState(false);
  const [uStartTimeError, setUStartTimeError] = useState(false);
  const [uFormatedTimeError, setUFormatedTimeError] = useState(false);

  // Loading state
  const [isUpdateLoading, setIsUpdateLoadingLocal] = useState(false);
  const updateLoadingState = (value) => {
    setIsUpdateLoadingLocal(value);
    if (setIsUpdateLoading) {
      setIsUpdateLoading(value);
    }
  };

  // ==================== Data State ====================
  const [groupedData, setGroupedData] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState([]);
  // OLD CODE - Commented out: selectedEntries state moved to parent (CardImportDataCalendar) for immediate header updates
  // const [selectedEntries, setSelectedEntries] = useState(new Set());

  // ==================== Refs ====================
  // Form and input refs
  const updateFormRef = useRef(null);
  const datePickerRef = useRef();
  const startInputRef = useRef(null);
  const endInputRef = useRef(null);
  const startRowInputRef = useRef(null);
  const endRowInputRef = useRef(null);
  const start12TimeInputRef = useRef(null);
  const end12TimeInputRef = useRef(null);
  const start12TimeRowInputRef = useRef(null);
  const end12TimeRowInputRef = useRef(null);

  // Dropdown refs
  const projectEditDropdownRef = useRef(null);
  const projectDropdownContentRef = useRef(null);
  const tagEditDropdownRef = useRef(null);

  // Edit mode sync refs
  const isInitializingEditRef = useRef(false);
  const isSyncingFromGlobalRef = useRef(false);
  const previousEditedIdRef = useRef(null);
  // ==================== Utility Functions ====================
  const currentTextCount = (text1, text2, text3) => {
    const text = `${text1} ${text2 ? "-" + text2 : ""} ${text3 ? text3 : ""}`;
    return text.length;
  };

  const formatTime = (time) => {
    return time.toString().padStart(2, "0");
  };

  const formatDuration = (duration) => {
    if (duration == null || isNaN(duration)) {
      return "00:00:00";
    }
    return `${formatTime(Math.floor(duration / 3600))}:${formatTime(Math.floor(parseInt((duration % 3600) / 60)))}:${formatTime(Math.floor(duration % 60))}`;
  };

  const toggleGroup = (groupIndex) => {
    setEditedId(null);
    setExpandedGroups((prevGroups) => {
      if (prevGroups.includes(groupIndex)) {
        return prevGroups.filter((index) => index !== groupIndex);
      } else {
        return [...prevGroups, groupIndex];
      }
    });
  };


  // ==================== Time Conversion Functions ====================
  const covertTimeSatmp = (dateEdit, sT) => {
    const date = new Date(dateEdit);
    const timeString = sT;
    const datePart = date.toLocaleDateString("en-US");
    const timePart = timeString;

    // Combine the date and time strings
    const combinedDateTimeString = `${datePart} ${timePart}`;
    return moment(combinedDateTimeString).format();
  };

  // ==================== Filtered Data ====================
  const filteredClientData = clientData
    .filter(
      (client) =>
        client.client_name.toLowerCase().includes(filter.toLowerCase()) ||
        client.projects.some((project) =>
          project.project_name.toLowerCase().includes(filter.toLowerCase())
        )
    )
    .sort((a, b) => a.client_name.localeCompare(b.client_name));

  const filteredTagItems = tagOptions
    .filter((item) =>
      item.tag_name.toLowerCase().includes(tagQuery.toLowerCase())
    )
    .sort((a, b) => a.tag_name.localeCompare(b.tag_name));

  // ==================== Event Handlers ====================
  const handleTagInputChange = (event) => {
    setTagQuery(event.target.value);
  };

  const handleDateIconClick = () => {
    datePickerRef.current.open();
  };

  const updateTimer = async (event) => {
    event.preventDefault();
    const id = editedId;
    const task = taskNameEdit;
    const date = new Date(dateEdit);
    const startTimeFormated = covertTimeSatmp(
      date,
      startTimeEdit && startTimeEdit.trim()
    );
    const endTimeFormated = covertTimeSatmp(
      date,
      endTimeEdit && endTimeEdit.trim()
    );
    const client = clientEdit;
    const clientId = clientIdEdit;
    const startdate = moment
      .tz(dateEdit, global.config.getTimeZone())
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    const postData = {
      task: task,
      project: projectIdEdit,
      date: startdate,
      oldDate: dateOldEdit,
      tag: tagIdEdit,
      billable: billableEdit,
      startTime: startTimeFormated,
      endTime: endTimeFormated,
      duration: uDuration,
      client: client,
      clientId: clientId,
      user: selectedUser,
      id: id,
      tz: global.config.getTimeZone(),
    };

    if (sprintIdEdit) {
      postData.sprint = sprintIdEdit;
    } else {
      postData.sprint = null;
    }

    // Validation before update
    const entryErrors = [];
    const startTime = new Date(startTimeFormated);
    const endTime = new Date(endTimeFormated);
    const entryDate = new Date(dateEdit);

    // Duration validation
    const duration = typeof uDuration === 'string' ? parseInt(uDuration, 10) : uDuration;
    if (!duration || typeof duration !== 'number' || duration <= 0 || isNaN(duration)) {
      entryErrors.push(`Invalid or missing duration`);
    }

    // StartTime and EndTime validation
    if (!startTime || isNaN(startTime.getTime())) {
      entryErrors.push(`Invalid or missing start time`);
    }

    if (!endTime || isNaN(endTime.getTime())) {
      entryErrors.push(`Invalid or missing end time`);
    }

    if (startTime && endTime && endTime <= startTime) {
      entryErrors.push(`End time must be after start time`);
    }

    // Duration consistency check
    if (startTime && endTime && duration) {
      const calculatedDuration = Math.floor((endTime - startTime) / 1000);
      if (Math.abs(duration - calculatedDuration) > 1) {
        entryErrors.push(`Duration mismatch`);
      }
    }

    // User validation
    const userId = typeof selectedUser === 'object' ? selectedUser._id : selectedUser;
    if (!userId || (typeof userId !== 'string' && typeof userId !== 'object')) {
      entryErrors.push(`Invalid or missing user`);
    }

    // Date validation
    if (!entryDate || isNaN(entryDate.getTime())) {
      entryErrors.push(`Invalid or missing date`);
    }

    // Task validation
    if (task === undefined || task === null || task.trim() === '') {
      entryErrors.push(`Missing task name`);
    }

    // Billable validation
    if (billableEdit === undefined || billableEdit === null) {
      entryErrors.push(`Missing billable status`);
    }

    // Project validation (required)
    const projectId = typeof projectIdEdit === 'object' && projectIdEdit !== null ? projectIdEdit._id : projectIdEdit;
    if (!projectId || projectId === null || projectId === undefined) {
      entryErrors.push(`Missing project (required)`);
    } else if (typeof projectId === 'string' && projectId.trim() === '') {
      entryErrors.push(`Empty project ID`);
    }

    // ClientId validation (required)
    const clientIdValue = typeof clientId === 'object' && clientId !== null ? clientId._id : clientId;
    if (!clientIdValue || clientIdValue === null || clientIdValue === undefined) {
      entryErrors.push(`Missing client ID (required)`);
    } else if (typeof clientIdValue === 'string' && clientIdValue.trim() === '') {
      entryErrors.push(`Empty client ID`);
    }

    // Sprint validation (optional but if exists, should be valid)
    if (sprintIdEdit !== null && sprintIdEdit !== undefined) {
      const sprintId = typeof sprintIdEdit === 'object' ? sprintIdEdit._id : sprintIdEdit;
      if (!sprintId || (typeof sprintId === 'string' && sprintId.trim() === '')) {
        entryErrors.push(`Invalid sprint ID`);
      }
    }

    // Tag validation (optional but if exists, should be valid)
    if (tagIdEdit !== null && tagIdEdit !== undefined) {
      const tagId = typeof tagIdEdit === 'object' ? tagIdEdit._id : tagIdEdit;
      if (!tagId || (typeof tagId === 'string' && tagId.trim() === '')) {
        entryErrors.push(`Invalid tag ID`);
      }
    }

    // If validation errors exist, show error, scroll to entry, and return
    if (entryErrors.length > 0) {
      toast.error(`Please fix validation errors:\n${entryErrors.map(err => `  - ${err}`).join('\n')}`, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Scroll to the entry with validation errors
      if (id) {
        setTimeout(() => {
          const entryElement = document.querySelector(`.date-${id}`);
          if (entryElement) {
            entryElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });

            // Add a temporary highlight effect
            entryElement.style.transition = 'box-shadow 0.3s ease';
            entryElement.style.boxShadow = '0 0 0 3px rgba(255, 0, 0, 0.3)';
            setTimeout(() => {
              entryElement.style.boxShadow = '';
            }, 2000);
          }
        }, 100);
      }

      return;
    }

    updateLoadingState(true);
    await axios
      .post("/api/time-track/importdata/custome-time-update", postData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (response) => {
        await dispatch(setTimerData(Date.now()));
        // setTimerUpdate((prevState) => !prevState);
        dispatch(setTimerData(Date.now()));
        setExpandedGroups([]);
        global.config.activityLog(
          window.location.href,
          "Timer",
          `Time Updated Successfully`
        );
        toast.success("Time Updated Successfully", {
          position: "bottom-right",
          autoClose: 1500,
        });
        setUEndTimeError(false);
        setUStartTimeError(false);
        updateLoadingState(false);

        // Close edit mode globally by setting globalEditedId to null
        // Use sync flag to prevent EditedId Change Effect from interfering
        isSyncingFromGlobalRef.current = true;
        setEditedId(null);

        // Also update global editedId to close edit mode in all components
        if (setGlobalEditedId) {
          setGlobalEditedId(null);
        }

        setTaskNameEdit(null);
        setProjectIdEdit(null);
        setProjectNameEdit(null);
        setSelectedUser(null);
        setSprintIdEdit(null);
        setSprintNameEdit(null);
        setDateEdit(null);
        setStartTimeEdit(TimestampConverter(null));
        setEndTimeEdit(TimestampConverter(null));
        setStartTimeEdit24(TimestampConverter(null));
        setEndTimeEdit24(TimestampConverter(null));
        setClientEdit(null);
        setClientIdEdit(null);
        setBillableEdit(null);

        // Remove entry ID from invalidEntryIds if validation passed
        if (setInvalidEntryIds && id) {
          setInvalidEntryIds((prev) => {
            const newSet = new Set(prev);
            newSet.delete(id);
            return newSet;
          });
        }

        if (refetchTimerData) {
          refetchTimerData();
        }

        // Clear the sync flag after a short delay
        setTimeout(() => {
          isSyncingFromGlobalRef.current = false;
        }, 50);
      })
      .catch((error) => {
        updateLoadingState(false);
        console.error("Error updating timer:", error);
        toast.error("Failed to update timer. Please try again.", {
          position: "bottom-right",
          autoClose: 3000,
        });
      });
  };

  // ==================== Time Input Parsing Functions ====================
  const parseTimeInput = (input) => {
    input = input.trim().toLowerCase();
    let timeRegex = /^(\d{1,2}):?(\d{2})?\s*([ap]m?)?$/;
    let match = input.match(timeRegex);

    if (!match) {
      timeRegex = /^(\d{1,2}):?(\d{1,2})?\s*([ap]m?)?$/;
      match = input.match(timeRegex);
      if (!match) return false;
    }

    let [_, hour, minutes, period] = match;
    hour = hour.padStart(2, "0");
    minutes = minutes ? minutes.padStart(2, "0") : "00";
    if (
      parseInt(hour, 10) > 12 ||
      parseInt(hour, 10) < 1 ||
      parseInt(minutes, 10) > 59
    ) {
      return false;
    }
    period = period
      ? period?.toUpperCase()
      : parseInt(hour, 10) < 12
        ? "AM"
        : "PM";

    return `${hour}:${minutes} ${period}`;
  };

  const timeFormatChange = (time) => {
    const input = parseTimeInput(time);
    if (input) {
      const momentTime = moment(input, "hh:mm A");
      if (!momentTime.isValid()) return false;
      return momentTime.format("hh:mm A");
    }
    return false;
  };

  useEffect(() => {
    if (startTimeEdit && endTimeEdit) {
      const timeString1 = startTimeEdit.trim();
      const timeString2 = endTimeEdit.trim();
      const format = "h:mm A";
      const time1 = moment(timeString1, format).tz(global.config.getTimeZone());
      const time2 = moment(timeString2, format).tz(global.config.getTimeZone());
      const timeDifferenceInSeconds = time2.diff(time1, "seconds");

      if (timeDifferenceInSeconds > 0) {
        setUDuration(parseInt(timeDifferenceInSeconds));
        setUFormatedTime(
          `${formatTime(
            Math.floor(parseInt(timeDifferenceInSeconds) / 3600)
          )}:${formatTime(
            Math.floor(parseInt((timeDifferenceInSeconds % 3600) / 60))
          )}:${formatTime(Math.floor(parseInt(timeDifferenceInSeconds) % 60))}`
        );
        setUStartTimeError(false);
        setUEndTimeError(false);
        setUFormatedTimeError(false);
      } else {
        setUStartTimeError(true);
        setUEndTimeError(true);
      }
    }
  }, [startTimeTemp, endTimeTemp]);

  const changeStartTime = (startTime) => {
    let formattedTime = timeFormatChange(startTime);
    if (formattedTime === false) {
      setUStartTimeError(true);
      return;
    }

    setStartTimeEdit(formattedTime);
    setStartTimeTemp(formattedTime);
  };

  const changeEndTime = (endTime) => {
    let formattedTime = timeFormatChange(endTime);
    if (formattedTime === false) {
      setUEndTimeError(true);
      return;
    }
    setEndTimeEdit(formattedTime);
    setEndTimeTemp(formattedTime);
  };

  const changeStartTime24 = (startTime) => {
    setStartTimeEdit24(startTime);
    if (formatChange(startTime)) {
      var convertedTim = convertTo24HourFormat(startTime);

      setStartTimeEdit24(convertedTim);
      setStartTimeEdit(convertTo12(convertedTim));
      setUStartTimeError(false);
    } else {
      setUStartTimeError(true);
    }

    if (
      !isValidTimeFormat(formatTimeTo24Hr(startTime)) ||
      !isValidTimeFormat(formatTimeTo24Hr(endTimeEdit24))
    ) {
      setUFormatedTimeError(true);
    }

    if (
      isEndTimeGreater(
        formatTimeTo24Hr(startTime),
        formatTimeTo24Hr(endTimeEdit24)
      )
    ) {
      const SrtTime = convertTo12(formatTimeTo24Hr(startTime));
      const endTime = convertTo12(formatTimeTo24Hr(endTimeEdit24));
      const format = "h:mm A";
      const time1 = moment(SrtTime, format).tz(global.config.getTimeZone());
      const time2 = moment(endTime, format).tz(global.config.getTimeZone());

      const timeDifferenceInSeconds = time2.diff(time1, "seconds");
      if (timeDifferenceInSeconds > 0) {
        setUDuration(parseInt(timeDifferenceInSeconds));
        setUFormatedTime(
          `${formatTime(
            Math.floor(parseInt(timeDifferenceInSeconds) / 3600)
          )}:${formatTime(
            Math.floor(parseInt((timeDifferenceInSeconds % 3600) / 60))
          )}:${formatTime(Math.floor(parseInt(timeDifferenceInSeconds) % 60))}`
        );
        setUStartTimeError(false);
        setUEndTimeError(false);
        setUFormatedTimeError(false);
      }
    } else {
      setUStartTimeError(true);
      setUFormatedTimeError(true);
    }
  };


  const changeEndTime24 = (endTime) => {
    setEndTimeEdit24(endTime);
    if (formatChange(endTime)) {
      var convertedTim = convertTo24HourFormat(endTime);

      setEndTimeEdit24(convertedTim);
      setEndTimeEdit(convertTo12(convertedTim));
      setUStartTimeError(false);
    } else {
      setUStartTimeError(true);
    }

    if (
      !isValidTimeFormat(startTimeEdit24) ||
      !isValidTimeFormat(convertTo24HourFormat(endTime))
    ) {
      setUFormatedTimeError(true);
    }
    if (isEndTimeGreater(startTimeEdit24, convertTo24HourFormat(endTime))) {
      const SrtTime = convertTo12(startTimeEdit24);
      const edTime = convertTo12(convertTo24HourFormat(endTime));
      const format = "h:mm A";
      const time1 = moment(SrtTime, format).tz(global.config.getTimeZone());
      const time2 = moment(edTime, format).tz(global.config.getTimeZone());
      const timeDifferenceInSeconds = time2.diff(time1, "seconds");
      if (timeDifferenceInSeconds > 0) {
        setUDuration(parseInt(timeDifferenceInSeconds));
        setUFormatedTime(
          `${formatTime(
            Math.floor(parseInt(timeDifferenceInSeconds) / 3600)
          )}:${formatTime(
            Math.floor(parseInt((timeDifferenceInSeconds % 3600) / 60))
          )}:${formatTime(Math.floor(parseInt(timeDifferenceInSeconds) % 60))}`
        );
        setUStartTimeError(false);
        setUEndTimeError(false);
        setUFormatedTimeError(false);
      }
    } else {
      setUEndTimeError(true);
      setUFormatedTimeError(true);
    }

  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        startInputRef.current &&
        !startInputRef.current.contains(event.target)
      ) {
        // Click occurred outside the input field, trigger changeStartTime24
        if (formatChange(startInputRef.current.value)) {
          changeStartTime24(startInputRef.current.value);
        } else {
          changeStartTime24(convertTo24Hour(startTimeEdit));
        }
      }
      if (endInputRef.current && !endInputRef.current.contains(event.target)) {
        if (formatChange(endInputRef.current.value)) {
          changeEndTime24(endInputRef.current.value);
        } else {
          changeEndTime24(convertTo24Hour(endTimeEdit));
        }
      }
      if (
        startRowInputRef.current &&
        !startRowInputRef.current.contains(event.target)
      ) {
        // Click occurred outside the input field, trigger changeStartTime24
        if (formatChange(startRowInputRef.current.value)) {
          changeStartTime24(startRowInputRef.current.value);
        } else {
          changeStartTime24(convertTo24Hour(startTimeEdit));
        }
      }
      if (
        endRowInputRef.current &&
        !endRowInputRef.current.contains(event.target)
      ) {
        if (formatChange(endRowInputRef.current.value)) {
          changeEndTime24(endRowInputRef.current.value);
        } else {
          changeEndTime24(convertTo24Hour(endTimeEdit));
        }
      }
      if (
        start12TimeInputRef.current &&
        !start12TimeInputRef.current.contains(event.target)
      ) {
        let formattedTime = timeFormatChange(start12TimeInputRef.current.value);
        if (formattedTime === false) {
          changeStartTime(startTimeTemp);
        } else {
          changeStartTime(start12TimeInputRef.current.value);
        }
      }
      if (
        end12TimeInputRef.current &&
        !end12TimeInputRef.current.contains(event.target)
      ) {
        let formattedTime = timeFormatChange(end12TimeInputRef.current.value);
        if (formattedTime === false) {
          changeEndTime(endTimeTemp);
        } else {
          changeEndTime(end12TimeInputRef.current.value);
        }
      }
      if (
        start12TimeRowInputRef.current &&
        !start12TimeRowInputRef.current.contains(event.target)
      ) {
        let formattedTime = timeFormatChange(
          start12TimeRowInputRef.current.value
        );
        if (formattedTime === false) {
          changeStartTime(startTimeTemp);
        } else {
          changeStartTime(start12TimeRowInputRef.current.value);
        }
      }
      if (
        end12TimeRowInputRef.current &&
        !end12TimeRowInputRef.current.contains(event.target)
      ) {
        let formattedTime = timeFormatChange(
          end12TimeRowInputRef.current.value
        );
        if (formattedTime === false) {
          changeEndTime(endTimeTemp);
        } else {
          changeEndTime(end12TimeRowInputRef.current.value);
        }
      }
    };
    document.body.addEventListener("click", handleClickOutside);
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, [changeStartTime24, changeEndTime24, changeStartTime, changeEndTime]);

  // ==================== Time Validation Functions ====================
  function validateTimeFormat(timeString) {
    const timeRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
    return timeRegex.test(timeString);
  }

  const timeShowEdit = (timeSec) => {
    if (validateTimeFormat(timeSec)) {
      const timeString = timeSec;
      const [hours, minutes, seconds] = timeString.split(":").map(Number);
      const totalSeconds =
        parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
      const date = dateEdit;
      const formattedDates = covertTimeSatmp(
        date,
        startTimeEdit && startTimeEdit.trim()
      );
      const timestampInSeconds = Math.floor(
        new Date(formattedDates).getTime() / 1000
      );
      setUDuration(parseInt(totalSeconds));
      const upcomingTimeInSeconds =
        parseInt(timestampInSeconds) + parseInt(totalSeconds);
      const upcomingTime = new Date(parseInt(upcomingTimeInSeconds) * 1000);
      const formattedTime =
        upcomingTime &&
        upcomingTime
          .toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          .replace("am", "AM")
          .replace("pm", "PM");
      setUFormatedTimeError(false);
      setEndTimeEdit(formattedTime);
      setUFormatedTimeError(false);
      setUStartTimeError(false);
      setUEndTimeError(false);
    } else {
      setUFormatedTimeError(true);
    }
    setUFormatedTime(timeSec);
  };

  // ==================== Data Processing Functions ====================
  const groupAndSumDurations = (data) => {
    const groupedData = [];
    let currentGroup = null;
    let totalDuration = 0;
    let totalHr = 0;
    let totalMin = 0;
    let totalSec = 0;
    const formatDate = (dateString) => {
      if (!dateString) {
        return null;
      }
      const dateObject = new Date(dateString);
      const formattedDate = tenantDayKey(dateObject);
      return formattedDate;
    };

    data.sort((a, b) => {
      if (a.task !== b.task) return a.task.localeCompare(b.task);
      if (a?.project?._id !== b?.project?._id) {
        if (!a?.project?._id) return 1;
        if (!b?.project?._id) return -1;
        return a?.project?._id.localeCompare(b?.project?._id);
      }
      if (a.tag && b.tag && a.tag?._id !== b.tag?._id)
        return a.tag?._id.localeCompare(b.tag?._id);
      return 0;
    });

    data.forEach((row) => {
      if (
        currentGroup &&
        currentGroup?.user?.trim() === row?.user?.trim() &&
        currentGroup.task.trim() === row.task.trim() &&
        ((!currentGroup.project && !row.project) || (currentGroup.project?._id === row.project?._id)) &&
        currentGroup.tag?._id === row.tag?._id &&
        formatDate(currentGroup.date) === formatDate(row.date)
      ) {
        // If the current row belongs to the same group, update the duration

        totalDuration += row.duration;
        totalHr += row.hr;
        totalMin += row.min;
        totalSec += row.sec;
        // Update startTime and endTime within the group
        if (row.startTime < currentGroup.startTime) {
          currentGroup.startTime = row.startTime;
        }

        if (row.endTime > currentGroup.endTime) {
          currentGroup.endTime = row.endTime;
        }

        currentGroup.entries.push(row);
      } else {
        // If the row starts a new group, push the previous group (if any) and start a new one
        if (currentGroup) {
          currentGroup.totalDuration = totalDuration;
          currentGroup.totalHr = totalHr;
          currentGroup.totalMin = totalMin;
          currentGroup.totalSec = totalSec;
          groupedData.push(currentGroup);
        }
        // Start a new group
        currentGroup = {
          _id: row._id,
          user: row.user,
          task: row.task,
          project: row.project,
          sprint: row.sprint,
          tag: row.tag,
          date: row.date,
          startTime: row.startTime,
          endTime: row.endTime,
          totalHr: row.hr,
          totalMin: row.min,
          totalSec: row.sec,
          totalDuration: row.duration,
          billable: row.billable,
          client: row.client,
          clientId: row.clientId,
          date: row.date,
          isSelected: row.isSelected !== undefined ? row.isSelected : true,
          entries: [row],
        };
        totalHr = row.hr;
        totalMin = row.min;
        totalSec = row.sec;
        totalDuration = row.duration;
      }
    });

    // Push the last group (if any)
    if (currentGroup) {
      currentGroup.totalDuration = totalDuration;
      currentGroup.totalHr = totalHr;
      currentGroup.totalMin = totalMin;
      currentGroup.totalSec = totalSec;
      groupedData.push(currentGroup);
    }

    groupedData.sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    });
    return groupedData;
  };

  // ==================== useEffect Hooks ====================
  // Initialize grouped data when item changes
  useEffect(() => {
    const getTableData = async () => {
      try {
        let filtered = item[1];
      } catch (err) {
        global.config.slackMessage(err.toString());
      }
    };
    getTableData();
    const updatedGroupedData = groupAndSumDurations(item[1]);
    setGroupedData(updatedGroupedData);
  }, [item, isUpdateLoading, timerData]);

  // Refetch timer data and handle keyboard events
  useEffect(() => {
    const refetch = async () => {
      if (refetchTimerData) {
        await refetchTimerData();
      }
    };
    refetch();
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
        setEditedId(null);
        if (setGlobalEditedId) {
          setGlobalEditedId(null);
        }
        setProjectEditDropdownOpen(false);
        setTagEditDropdownOpen(false);
        setUEndTimeError(false);
        setUStartTimeError(false);
        setUFormatedTime(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [timerData]);

  // OLD CODE - Commented out: selectedEntries initialization moved to parent (CardImportDataCalendar)
  // This allows the header to access selectedEntries immediately when checkboxes change
  // Initialize selectedEntries based on isSelected field from data
  // useEffect(() => {
  //   if (groupedData.length > 0) {
  //     const selectedEntryIds = new Set();
  //     groupedData.forEach((group) => {
  //       // Check if group is selected (default to true if isSelected is undefined)
  //       if (group.isSelected !== false) {
  //         selectedEntryIds.add(group._id);
  //       }
  //       // If group has multiple entries, check individual row isSelected status
  //       if (group.entries && group.entries.length > 1) {
  //         group.entries.forEach((row) => {
  //           if (row._id && row.isSelected !== false) {
  //             selectedEntryIds.add(row._id);
  //           }
  //         });
  //       }
  //     });
  //     setSelectedEntries(selectedEntryIds);
  //   }
  // }, [groupedData]);

  // Update selectedEntries when groupedData changes (for groups with multiple entries)
  // This syncs the parent state with groupedData changes
  // Note: Only depends on groupedData to avoid infinite loops
  useEffect(() => {
    if (groupedData.length > 0 && setSelectedEntries) {
      setSelectedEntries((prevSelectedEntries) => {
        const selectedEntryIds = new Set(prevSelectedEntries || new Set());
        let hasChanges = false;

        groupedData.forEach((group) => {
          // Check if group is selected (default to true if isSelected is undefined)
          if (group.isSelected !== false) {
            if (!selectedEntryIds.has(group._id)) {
              selectedEntryIds.add(group._id);
              hasChanges = true;
            }
          } else {
            if (selectedEntryIds.has(group._id)) {
              selectedEntryIds.delete(group._id);
              hasChanges = true;
            }
          }
          // If group has multiple entries, check individual row isSelected status
          if (group.entries && group.entries.length > 1) {
            group.entries.forEach((row) => {
              if (row._id && row.isSelected !== false) {
                if (!selectedEntryIds.has(row._id)) {
                  selectedEntryIds.add(row._id);
                  hasChanges = true;
                }
              } else if (row._id) {
                if (selectedEntryIds.has(row._id)) {
                  selectedEntryIds.delete(row._id);
                  hasChanges = true;
                }
              }
            });
          }
        });

        return hasChanges ? selectedEntryIds : prevSelectedEntries;
      });
    }
  }, [groupedData, setSelectedEntries]);

  // Refetch timer data when expanded groups or selected user changes
  useEffect(() => {
    if (refetchTimerData) {
      refetchTimerData();
    }
  }, [expandedGroups, selectedUser, refetchTimerData]);

  // Sync local editedId with global editedId
  useEffect(() => {
    // Skip sync if we're currently initializing edit state (to prevent interference)
    if (isInitializingEditRef.current) {
      return;
    }

    // Get all entry IDs in this component
    const entryIds = new Set();
    groupedData.forEach(group => {
      entryIds.add(group._id);
      if (group.entries && group.entries.length > 0) {
        group.entries.forEach(row => {
          if (row._id) {
            entryIds.add(row._id);
          }
        });
      }
    });

    if (!globalEditedId) {
      // If globalEditedId is null, close this component's edit mode
      if (editedId) {
        // Set flag to prevent EditedId Change Effect from updating globalEditedId
        isSyncingFromGlobalRef.current = true;
        setEditedId(null);
        setProjectEditDropdownOpen(false);
        setTagEditDropdownOpen(false);
        // Clear the flag after state updates have been processed
        setTimeout(() => {
          isSyncingFromGlobalRef.current = false;
        }, 50);
      }
    } else if (globalEditedId !== editedId) {
      // If globalEditedId is set and different from local editedId
      if (entryIds.has(globalEditedId)) {
        // The globalEditedId matches an entry in this component
        // Set flag to prevent EditedId Change Effect from updating globalEditedId
        isSyncingFromGlobalRef.current = true;
        // Set the local editedId to match and find the entry to initialize edit state
        setEditedId(globalEditedId);
        // Find the entry and initialize its edit state
        let targetEntry = null;
        let isRowEntry = false;
        for (const group of groupedData) {
          if (group._id === globalEditedId) {
            targetEntry = group;
            isRowEntry = false;
            break;
          }
          if (group.entries && group.entries.length > 0) {
            for (const row of group.entries) {
              if (row._id === globalEditedId) {
                targetEntry = row;
                isRowEntry = true;
                break;
              }
            }
            if (targetEntry) break;
          }
        }
        if (targetEntry) {
          // Initialize edit state for the target entry
          setProjectEditDropdownOpen(false);
          setTagEditDropdownOpen(false);
          setTaskNameEdit(targetEntry.task);
          setProjectIdEdit(targetEntry.project?._id || null);
          setProjectNameEdit(targetEntry.project?.project_name || "");
          setSelectedUser(targetEntry.user);

          if (targetEntry.sprint) {
            setSprintNameEdit(targetEntry.sprint.sprint_name);
            setSprintIdEdit(targetEntry.sprint._id);
          } else {
            setSprintIdEdit("");
            setSprintNameEdit("");
          }

          setDateEdit(zoneConverter(targetEntry.date, global.config.getTimeZone(), "YYYY-MM-DD HH:mm:ss"));
          setTagIdEdit(targetEntry.tag && targetEntry.tag._id);

          const startTime = TimestampConverter(targetEntry.startTime);
          const endTime = TimestampConverter(targetEntry.endTime);

          setStartTimeEdit(startTime);
          setEndTimeEdit(endTime);
          setStartTimeTemp(startTime);
          setEndTimeTemp(endTime);
          setStartTimeEdit24(convertTo24HourFormatback(startTime));
          setEndTimeEdit24(convertTo24HourFormatback(endTime));

          setClientEdit(targetEntry.client);
          setClientIdEdit(targetEntry.clientId);
          setBillableEdit(targetEntry.billable);

          const duration = isRowEntry ? targetEntry.duration : targetEntry.totalDuration;
          setUFormatedTime(formatDuration(duration));
          setUDuration(duration);

          setUStartTimeError(false);
          setUEndTimeError(false);
          setUFormatedTimeError(false);
          // Clear the sync flag after state updates have been processed
          // Use requestAnimationFrame + setTimeout to ensure the EditedId Change Effect has run
          // and seen the updated editedId value
          // Also notify parent after sync completes
          requestAnimationFrame(() => {
            setTimeout(() => {
              isSyncingFromGlobalRef.current = false;
              // Notify parent after sync completes with the correct editedId value
              if (onEditedIdChange && editedId === globalEditedId) {
                onEditedIdChange(editedId, updateFormRef);
              }
            }, 100);
          });
        } else {
          isSyncingFromGlobalRef.current = false;
        }
      } else {
        // The globalEditedId doesn't match any entry in this component
        // If this component has any entry in edit mode, close it (because a different entry is now being edited globally)
        if (editedId) {
          // This component has an entry in edit mode, but globalEditedId is for a different entry
          // Close edit mode to ensure only one entry is editable at a time
          isSyncingFromGlobalRef.current = true;
          setEditedId(null);
          setProjectEditDropdownOpen(false);
          setTagEditDropdownOpen(false);
          setTimeout(() => {
            isSyncingFromGlobalRef.current = false;
          }, 50);
        } else {
          // Entry is not in this component and this component doesn't have any entry in edit mode
          // Do nothing - no action needed
        }
      }
    } else {
    }
    // Only depend on globalEditedId and groupedData, not editedId
    // This prevents the effect from re-running when we update editedId from within it
  }, [globalEditedId, groupedData]);

  // Notify parent when editedId changes and form ref is available
  useEffect(() => {
    const currentEditedId = editedId;
    const previousEditedId = previousEditedIdRef.current;
    const currentIsInitializing = isInitializingEditRef.current;
    const currentIsSyncing = isSyncingFromGlobalRef.current;
    const currentGlobalEditedId = globalEditedId;

    // Update the ref for next time
    previousEditedIdRef.current = currentEditedId;

    // Only notify parent if we're not syncing from global (to avoid stale values)
    // When syncing from global, the parent already knows about the change
    // Also skip if editedId is null and globalEditedId is not null (to avoid resetting globalEditedId)
    if (onEditedIdChange && !currentIsSyncing && !(currentEditedId === null && currentGlobalEditedId !== null)) {
      onEditedIdChange(currentEditedId, updateFormRef);
    } else {
    }

    // Update global editedId when local changes
    // Only update if:
    // 1. We're not currently initializing (to avoid circular updates during initializeEditState)
    // 2. We're not syncing from global (to avoid circular updates during sync effect)
    // 3. The globalEditedId doesn't already match editedId (to avoid unnecessary updates)
    // 4. editedId is not null (we don't want to set global to null unless we're syncing)
    // 5. editedId actually changed from the previous value (to avoid duplicate updates)
    if (
      setGlobalEditedId &&
      !currentIsInitializing &&
      !currentIsSyncing &&
      currentGlobalEditedId !== currentEditedId &&
      currentEditedId !== null &&
      previousEditedId !== currentEditedId
    ) {
      setGlobalEditedId(currentEditedId);
    } else {
    }
  }, [editedId, onEditedIdChange, setGlobalEditedId, globalEditedId]);

  // Close project/tag dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const projectNode = projectEditDropdownRef.current;
      const projectDropdownContent = projectDropdownContentRef.current;
      const tagNode = tagEditDropdownRef.current;

      // Check if click is outside project dropdown (both container and dropdown content)
      if (projectEditDropdownOpen) {
        const isClickInsideProjectContainer = projectNode && projectNode.contains(event.target);
        const isClickInsideDropdown = projectDropdownContent && projectDropdownContent.contains(event.target);

        if (!isClickInsideProjectContainer && !isClickInsideDropdown) {
          setProjectEditDropdownOpen(false);
          setFilter("");
          setSelectedClients(new Set());
          setSelectedProject(null);
        }
      }

      // Check if click is outside tag dropdown
      if (
        tagEditDropdownOpen &&
        tagNode &&
        !tagNode.contains(event.target)
      ) {
        setTagEditDropdownOpen(false);
      }
    };

    // Only add listener if dropdown is open
    if (projectEditDropdownOpen || tagEditDropdownOpen) {
      // Use a small timeout to ensure the refs are set after render
      const timeoutId = setTimeout(() => {
        document.addEventListener("mousedown", handleClickOutside);
      }, 0);

      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [projectEditDropdownOpen, tagEditDropdownOpen]);

  // Calculate duration when start/end times change
  useEffect(() => {
    if (startTimeEdit && endTimeEdit) {
      const timeString1 = startTimeEdit.trim();
      const timeString2 = endTimeEdit.trim();
      const format = "h:mm A";
      const time1 = moment(timeString1, format).tz(global.config.getTimeZone());
      const time2 = moment(timeString2, format).tz(global.config.getTimeZone());
      const timeDifferenceInSeconds = time2.diff(time1, "seconds");

      if (timeDifferenceInSeconds > 0) {
        setUStartTimeError(false);
        setUEndTimeError(false);
        setUFormatedTimeError(false);
      } else {
        setUStartTimeError(true);
        setUEndTimeError(true);
      }
    }
    startTimeEdit && setStartTimeEdit24(convertTo24Hour(startTimeEdit));
    endTimeEdit && setEndTimeEdit24(convertTo24Hour(endTimeEdit));
  }, [startTimeEdit, endTimeEdit]);

  // ==================== Edit State Management Functions ====================
  // Initialize edit state from a group/row object
  const initializeEditState = (entry, isRow = false, setTimeInputActive = false) => {
    // Check if entry is selected - prevent edit mode if not selected
    const isEntrySelected = entry.isSelected !== false && selectedEntries.has(entry._id);
    if (!isEntrySelected) {
      // toast.error("Please select the entry first to edit it", {
      //   position: "bottom-right",
      //   autoClose: 500,
      // });
      return;
    }

    // Set flag to prevent sync effect from interfering
    isInitializingEditRef.current = true;

    // Set global editedId first - this will close other entries via sync effect
    if (setGlobalEditedId) {
      setGlobalEditedId(entry._id);
    }
    // Then set local editedId and initialize the edit state
    setEditedId(entry._id);
    setProjectEditDropdownOpen(false);
    setTagEditDropdownOpen(false);
    setTaskNameEdit(entry.task);
    setProjectIdEdit(entry.project?._id || null);
    setProjectNameEdit(entry.project?.project_name || "");
    setSelectedUser(entry.user);

    if (entry.sprint) {
      setSprintNameEdit(entry.sprint.sprint_name);
      setSprintIdEdit(entry.sprint._id);
    } else {
      setSprintIdEdit("");
      setSprintNameEdit("");
    }

    setDateEdit(zoneConverter(entry.date, global.config.getTimeZone(), "YYYY-MM-DD HH:mm:ss"));

    setTagIdEdit(entry.tag && entry.tag._id);

    const startTime = TimestampConverter(entry.startTime);
    const endTime = TimestampConverter(entry.endTime);

    setStartTimeEdit(startTime);
    setEndTimeEdit(endTime);
    setStartTimeTemp(startTime);
    setEndTimeTemp(endTime);
    setStartTimeEdit24(convertTo24HourFormatback(startTime));
    setEndTimeEdit24(convertTo24HourFormatback(endTime));

    setClientEdit(entry.client);
    setClientIdEdit(entry.clientId);
    setBillableEdit(entry.billable);

    const duration = isRow ? entry.duration : entry.totalDuration;
    setUFormatedTime(formatDuration(duration));
    setUDuration(duration);

    if (setTimeInputActive) {
      setIsTimeInputActive(true);
    }

    setUStartTimeError(false);
    setUEndTimeError(false);
    setUFormatedTimeError(false);

    // Clear the flag after a short delay to allow state updates to complete
    setTimeout(() => {
      isInitializingEditRef.current = false;
    }, 100);
  };

  // ==================== Render Helper Functions ====================
  // Render checkbox for entry selection
  const renderCheckbox = (entryId) => {
    const handleCheckboxChange = async (e) => {
      const isSelected = e.target.checked;
      const newSelectedEntries = new Set(selectedEntries);

      // Optimistically update UI
      if (isSelected) {
        newSelectedEntries.add(entryId);
      } else {
        newSelectedEntries.delete(entryId);
        // Remove entry ID from invalidEntryIds when deselecting
        if (setInvalidEntryIds) {
          setInvalidEntryIds((prev) => {
            const newSet = new Set(prev);
            newSet.delete(entryId);
            return newSet;
          });
        }
      }
      setSelectedEntries(newSelectedEntries);

      // Call API to update backend
      try {
        await axios.post(
          "/api/time-track/importdata/toggle-entry-selection",
          {
            entryId: entryId,
            isSelected: isSelected,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Refetch timer data after successful update
        if (refetchTimerData) {
          refetchTimerData();
        }
      } catch (error) {
        console.error("Error toggling entry selection:", error);
        // Revert on error
        const revertedSelectedEntries = new Set(selectedEntries);
        if (isSelected) {
          revertedSelectedEntries.delete(entryId);
        } else {
          revertedSelectedEntries.add(entryId);
          // Re-add to invalidEntryIds if it was there before (revert)
          // Note: We can't perfectly revert invalidEntryIds without tracking previous state,
          // but this is acceptable since validation will re-add it if needed
        }
        setSelectedEntries(revertedSelectedEntries);
        toast.error("Failed to update entry selection", {
          position: "bottom-right",
          autoClose: 2000,
        });
      }
    };

    return (
      <div className="entry-checkbox-container">
        <input
          type="checkbox"
          checked={selectedEntries.has(entryId)}
          onChange={handleCheckboxChange}
          className="entry-checkbox"
        />
      </div>
    );
  };

  // Handle project selection
  const handleProjectSelect = (project, client) => {
    setSprintIdEdit("");
    setSprintNameEdit("");
    setProjectIdEdit(project._id);
    setProjectNameEdit(project.project_name);
    setClientEdit(client.client_name);
    setClientIdEdit(client._id);
    setBillableEdit(project.is_billable);
    setProjectEditDropdownOpen(false);
  };

  // Handle sprint selection
  const handleSprintSelect = (sprint, project, client) => {
    setSprintIdEdit(sprint._id);
    setSprintNameEdit(sprint.sprint_name);
    setProjectIdEdit(project._id);
    setProjectNameEdit(project.project_name);
    setClientEdit(client.client_name);
    setClientIdEdit(client._id);
    setBillableEdit(project.is_billable);
    setProjectEditDropdownOpen(false);
  };

  // Handle filter change
  const handleFilterChange = (filterValue) => {
    setFilter(filterValue);
    if (filterValue === "") {
      setSelectedClients(new Set());
    } else {
      const matchingClients = filteredClientData.filter((client) =>
        client.projects.some((project) =>
          project.project_name.toLowerCase().includes(filterValue.toLowerCase())
        )
      );
      setSelectedClients(new Set(matchingClients));
    }
  };

  // Toggle client selection
  const toggleClientSelection = (client) => {
    if (client.projects.length > 0) {
      const newSelectedClients = new Set(selectedClients);
      if (selectedClients.has(client)) {
        newSelectedClients.delete(client);
      } else {
        newSelectedClients.add(client);
      }
      setSelectedClients(newSelectedClients);
    }
  };

  // Render project dropdown
  const renderProjectDropdown = () => {
    if (!projectEditDropdownOpen) return null;

    return (
      <div
        ref={projectDropdownContentRef}
        className="custom-dropdown"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <input
          type="text"
          className="search-bar"
          placeholder="Find Project or Client"
          value={filter || ""}
          onChange={(e) => handleFilterChange(e.target.value)}
          autoComplete="off"
          disabled={isLoadingClientProjectDetails}
        />
        <ul className="client-list">
          {isLoadingClientProjectDetails ? (
            <>
              {Array.from({ length: 3 }).map((_, index) => (
                <div key={`skeleton-client-${index}`} className="main-outer-item-dd">
                  <div className="client-name1" style={{ pointerEvents: "none", cursor: "default" }}>
                    <div
                      style={{
                        width: "150px",
                        height: "20px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        marginBottom: "8px",
                      }}
                    />
                  </div>
                </div>
              ))}
            </>
          ) : (
            filteredClientData.map((client) => (
              <div key={client._id} className="main-outer-item-dd">
                <div
                  className={`client-name1 ${selectedClients.has(client) ? "selected" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleClientSelection(client);
                  }}
                >
                  <span className="main-project">{client.client_name} </span>
                  {client.projects.length > 0 && (
                    <span className={`arrow ${selectedClients.has(client) ? "open" : ""}`}>
                      <span className="main-project-title">
                        {client.projects.length} Projects
                      </span>
                      {selectedClients.has(client) ? (
                        <img src={TopArrow} alt="Open" />
                      ) : (
                        <img src={DownArrow} alt="Close" />
                      )}
                    </span>
                  )}
                </div>
                {selectedClients.has(client) && (
                  <div className="project-name1-outer">
                    {client.projects.length === 0 ? (
                      <div>No projects under this client</div>
                    ) : (
                      client.projects
                        .filter((project) =>
                          project.project_name.toLowerCase().includes(filter.toLowerCase())
                        )
                        .sort((a, b) => a.project_name.localeCompare(b.project_name))
                        .map((project) => (
                          <div key={project._id}>
                            <div className={`project-name1 ${selectedProject === project ? "selected" : ""}`}>
                              {/* <div onClick={() => handleProjectSelect(project, client)}> */}
                              <div onClick={(e) => {
                                e.stopPropagation();
                                setSelectedProject(selectedProject === project ? null : project);
                              }}>
                                <span className="project-dd-title">{project.project_name} </span>
                              </div>
                              <div>
                                {project.sprints.length > 0 && (
                                  <span
                                    className={`arrow ${selectedProject === project ? "open" : ""}`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedProject(selectedProject === project ? null : project);
                                    }}
                                  >
                                    <span className="main-project-title">
                                      {project.sprints.length} Sprints
                                    </span>
                                    {selectedProject === project ? (
                                      <img src={TopArrow} alt="Open" />
                                    ) : (
                                      <img src={DownArrow} alt="Close" />
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                            {selectedProject === project && (
                              <div>
                                {project.sprints.length === 0 ? (
                                  <div style={{
                                    pointerEvents: 'none',
                                    cursor: 'default',
                                    opacity: 0.6,
                                    fontStyle: 'italic',
                                    color: '#999',
                                    paddingLeft: '20px'
                                  }}>
                                    No sprints under this project
                                  </div>
                                ) : (
                                  <ul className="sprint-list">
                                    {project.sprints
                                      .sort((a, b) => a.sprint_name.localeCompare(b.sprint_name))
                                      .map((sprint) => (
                                        <li
                                          key={sprint._id}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleSprintSelect(sprint, project, client);
                                          }}
                                        >
                                          {sprint.sprint_name}
                                        </li>
                                      ))}
                                  </ul>
                                )}
                              </div>
                            )}
                          </div>
                        ))
                    )}
                  </div>
                )}
              </div>
            ))
          )}
        </ul>
      </div>
    );
  };

  // Render tag dropdown
  const renderTagDropdown = () => {
    if (!tagEditDropdownOpen) return null;

    return (
      <div className="custom-dropdown">
        <input
          type="text"
          className="search-bar"
          placeholder="Search..."
          value={tagEdit || ""}
          onChange={handleTagInputChange}
          autoComplete="off"
          disabled={isLoadingTagDetails}
        />
        <ul className="client-list">
          {isLoadingTagDetails ? (
            <>
              {Array.from({ length: 3 }).map((_, index) => (
                <li
                  key={`skeleton-tag-${index}`}
                  className="cursor"
                  style={{ pointerEvents: "none", cursor: "default" }}
                >
                  <div
                    style={{
                      width: "120px",
                      height: "20px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                </li>
              ))}
            </>
          ) : (
            filteredTagItems.map((group) => (
              <li
                className="cursor"
                key={group._id}
                onClick={(e) => {
                  setTagEdit(group.tag_name);
                  setTagIdEdit(group._id);
                  setTagEditDropdownOpen(false);
                }}
              >
                {group.tag_name}
              </li>
            ))
          )}
        </ul>
      </div>
    );
  };

  // Render time inputs
  const renderTimeInputs = (startTime, endTime, is24Hour, isRow = false, onStartChange, onEndChange, onStartBlur, onEndBlur, onStartFocus, onEndFocus, startError, endError) => {
    // Ensure startTime and endTime are always strings, never null or undefined
    const safeStartTime = startTime ?? "";
    const safeEndTime = endTime ?? "";

    if (is24Hour) {
      return (
        <>
          <input
            ref={isRow ? startRowInputRef : startInputRef}
            type="text"
            name="start_time"
            value={safeStartTime}
            style={{ backgroundColor: startError && "#fddada" }}
            onChange={onStartChange}
            onBlur={onStartBlur}
            onFocus={onStartFocus}
            className={`${isRow ? "edit-time edit-time-start" : "time-show edit-time-start"}`}
            autoComplete="off"
          />
          -
          <input
            ref={isRow ? endRowInputRef : endInputRef}
            type="text"
            name="end_time"
            value={safeEndTime}
            style={{ backgroundColor: endError && "#fddada" }}
            onChange={onEndChange}
            onBlur={onEndBlur}
            onFocus={onEndFocus}
            className={`${isRow ? "edit-time edit-time-end" : "time-show edit-time-end"}`}
            autoComplete="off"
          />
        </>
      );
    } else {
      return (
        <>
          <input
            ref={isRow ? start12TimeRowInputRef : start12TimeInputRef}
            type="text"
            name="start_time"
            value={safeStartTime}
            style={{ backgroundColor: startError && "#fddada" }}
            onChange={onStartChange}
            onBlur={onStartBlur}
            onFocus={onStartFocus}
            className={`${isRow ? "edit-time edit-time-start" : "time-show edit-time-start"}`}
            autoComplete="off"
          />
          -
          <input
            ref={isRow ? end12TimeRowInputRef : end12TimeInputRef}
            type="text"
            name="end_time"
            value={safeEndTime}
            style={{ backgroundColor: endError && "#fddada" }}
            onChange={onEndChange}
            onBlur={onEndBlur}
            onFocus={onEndFocus}
            className={`${isRow ? "edit-time edit-time-end" : "time-show edit-time-end"}`}
            autoComplete="off"
          />
        </>
      );
    }
  };

  // Render billable icon
  const renderBillableIcon = (isBillable) => {
    return (
      <div className={`billable-timing-sec ${isBillable ? "billable-timing" : "non-billable-timing"}`}>
        <svg width="13" height="20" viewBox="0 0 13 20" fill={isBillable ? "#405BFF" : "none"} xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.544 19.32V17.4C3.264 17.184 1.464 16.2 0.024 14.688L1.872 12.792C3.288 14.232 4.848 14.952 6.648 14.904C8.304 14.88 9.408 14.232 9.408 13.176C9.408 11.808 8.064 11.664 5.616 11.04C3.336 10.464 0.384 9.72 0.384 6.792C0.384 4.32 2.736 2.568 5.592 2.376V0.503999H7.248V2.424C9.024 2.64 10.776 3.408 12.192 4.848L10.368 6.744C8.952 5.448 7.704 4.8 6.072 4.8C4.32 4.8 3.168 5.424 3.168 6.48C3.168 7.656 4.464 8.064 6.936 8.592C9.24 9.12 12.384 9.768 12.384 12.888C12.384 15.6 10.08 17.184 7.2 17.4V19.32H5.544Z"
            fill="#96A8BA"
          />
        </svg>
      </div>
    );
  };

  // Render project name display
  const renderProjectNameDisplay = (projectName, sprintName, clientName, projectId, isEditMode = false, classNameModifier = "project-tracker-inner", maxWidth = null) => {
    const hasProject = projectName || projectId;
    const displayText = hasProject ? projectName : "Sprint/Project";
    const sprintText = sprintName ? ` - ${sprintName}` : "";
    const textCount = currentTextCount(displayText, sprintText, hasProject ? clientName || "" : "");
    const sizeClass = textCount < 21 ? "small" : "large";

    const commonStyle = {
      display: "inline-block",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      height: "22px",
      ...(maxWidth && { maxWidth }),
    };

    return (
      <>
        <span className={`tooltip-tracker ${sizeClass} ${hasProject ? "tooltip-tracker-show" : "tooltip-tracker-hide"}`}>
          {hasProject ? (
            <>
              {displayText}{sprintText}
              <input type="hidden" name="project" value={projectId || ""} />
              {clientName && (
                <div className="project-name-tracker">{clientName}</div>
              )}
            </>
          ) : (
            <div className="tooltip-tracker-hide">
              <img src={Plus} alt="plus" />{" "}Sprint/Project
            </div>
          )}
        </span>
        <span className={`${classNameModifier} ${sizeClass}`} style={commonStyle}>
          {hasProject ? (
            <>
              {displayText}{sprintText}
              <input type="hidden" name="project" value={projectId || ""} />
              {clientName && (
                <div className="project-name-tracker">{clientName}</div>
              )}
            </>
          ) : (
            <div className="tooltip-tracker-hide">
              <img src={Plus} alt="plus" />{" "}Sprint/Project
            </div>
          )}
        </span>
      </>
    );
  };

  // Render project name with conditional client display
  const renderProjectNameWithClient = (projectName, sprintName, clientName, showClient = true) => {
    const hasProject = projectName && projectName !== "No Project";
    const sprintText = sprintName ? ` - ${sprintName}` : "";

    return (
      <>
        {hasProject ? (
          <>
            {projectName}{sprintText}
            {showClient && clientName && (
              <div className="project-name-tracker">{clientName}</div>
            )}
          </>
        ) : (
          <div className="tooltip-tracker-hide">
            <img src={Plus} alt="plus" />{" "}Sprint/Project
          </div>
        )}
      </>
    );
  };

  // ==================== Constants and Reusable Components ====================
  // Common style objects
  const commonTextStyle = {
    display: "inline-block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    height: "22px",
  };

  const pointerCursorStyle = { cursor: "pointer" };

  // Tag icon SVG component
  const TagIconSVG = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.9119 23C13.1542 23 12.4419 22.7048 11.9066 22.1695L1.83081 12.0945C1.17489 11.4386 0.881077 10.5022 1.04426 9.5892L1.99398 4.28519C2.20208 3.12282 3.12293 2.202 4.28535 1.99391L9.58953 1.04422C10.5067 0.881044 11.4395 1.1753 12.0949 1.83074L22.1712 11.9052C23.2763 13.0108 23.2763 14.8102 22.1712 15.9158L15.9172 22.1695C15.3819 22.7053 14.6696 23 13.9119 23ZM20.8749 13.2014L10.7992 3.12649C10.6094 2.93674 10.3532 2.83269 10.0896 2.83269C10.0309 2.83269 9.97181 2.83773 9.91314 2.84827L4.60895 3.79797C4.19826 3.87131 3.87282 4.19673 3.79902 4.60787L2.84929 9.91187C2.79154 10.2346 2.89559 10.5659 3.12706 10.7979L13.2028 20.8728C13.5814 21.2514 14.2415 21.2514 14.6201 20.8728L20.874 14.6191C21.265 14.2281 21.265 13.5919 20.874 13.201L20.8749 13.2014Z"
        fill="#96A8BA"
        stroke="white"
        strokeWidth="0.2"
      />
      <path
        d="M7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5C9 8.32843 8.32843 9 7.5 9Z"
        fill="#96A8BA"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );

  // Date picker icon SVG component
  const DatePickerIconSVG = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className="rs-picker-toggle-caret rs-icon"
      aria-label="calendar"
      data-category="legacy"
    >
      <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
    </svg>
  );

  // Helper function to render project name with tooltip wrapper
  const renderProjectNameWithTooltip = (projectName, sprintName, clientName, classNameModifier = "project-tracker-inner", maxWidth = null) => {
    const textCount = currentTextCount(
      projectName || "",
      sprintName || "",
      clientName || ""
    );
    const sizeClass = textCount < 21 ? "small" : "large";
    const style = maxWidth ? { ...commonTextStyle, maxWidth } : commonTextStyle;

    return (
      <>
        <span className={`tooltip-tracker ${sizeClass}`}>
          {renderProjectNameWithClient(projectName, sprintName, clientName)}
        </span>
        <span className={`${classNameModifier} ${sizeClass}`} style={style}>
          {renderProjectNameWithClient(projectName, sprintName, clientName)}
        </span>
      </>
    );
  };

  // Helper function to render read-only time inputs
  const renderReadOnlyTimeInputs = (startTime, endTime, is24Hour = false) => {
    const startValue = is24Hour
      ? convertTo24HourFormatback(TimestampConverter(startTime))
      : TimestampConverter(startTime);
    const endValue = is24Hour
      ? convertTo24HourFormatback(TimestampConverter(endTime))
      : TimestampConverter(endTime);

    return (
      <>
        <input
          style={pointerCursorStyle}
          type="text"
          name="start_time"
          value={startValue ?? ""}
          autoComplete="off"
          className="time-show edit-time-start"
          readOnly
        />
        -
        <input
          style={pointerCursorStyle}
          type="text"
          name="end_time"
          value={endValue ?? ""}
          autoComplete="off"
          className="time-show edit-time-end"
          readOnly
        />
      </>
    );
  };

  // Helper function to handle project dropdown toggle
  const handleProjectDropdownToggle = () => {
    setProjectEditDropdownOpen(!projectEditDropdownOpen);
    setFilter("");
    setSelectedClients(new Set());
    setSelectedProject(null);
    setTagEditDropdownOpen(false);
    setUStartTimeError(false);
    setUEndTimeError(false);
    setUFormatedTimeError(false);
  };

  // Helper function to render tag icon or name
  const renderTagIconOrName = (tagName, tagEditValue = null) => {
    const displayTag = tagEditValue || tagName;
    return displayTag ? (
      displayTag
    ) : (
      <TagIconSVG />
    );
  };

  // ==================== Main Render ====================
  return (
    <Card.Body className="body-mg">
      <>
        {groupedData
          .sort((a, b) => {
            const taskComparison = a.task.trim().localeCompare(b.task.trim());
            return new Date(b.startTime) - new Date(a.startTime);
          })
          .map((group, groupIndex) => (
            <React.Fragment key={groupIndex}>
              <form ref={updateFormRef} onSubmit={updateTimer}>
                <div
                  className={`timetracker-inner data-time-tracker overview-sec-timer date-${group._id} ${group._id === editedId && group.entries.length === 1 ? "editer" : ""}`}
                  style={{
                    backgroundColor: (group._id === editedId && group.entries.length === 1) ? "#f0f7f9" : (group.entries.length > 1 ? "" : (invalidEntryIds.has(group._id) ? "#fff9f9" : "")),
                    opacity: group._id === editedId && group.entries.length === 1 ? "1" : (selectedEntries.has(group._id) ? "1" : "0.4"),
                    border: (group._id === editedId && group.entries.length === 1) ? "" : (group.entries.length > 1 ? (group.entries.some(row => invalidEntryIds.has(row._id)) ? "1px solid red" : "") : (invalidEntryIds.has(group._id) ? "1px solid red" : "")),
                    // filter: (group._id === editedId && group.entries.length === 1) || selectedEntries.has(group._id) ? "none" : "blur(4px)",
                  }}
                >
                  <div className="merge-tracker">
                    <div className="overview-sec-timer-inner">
                      <div className="project-name">
                        {group.entries.length > 1 && (
                          <div onClick={() => toggleGroup(groupIndex)} style={{ cursor: "pointer" }} className="count-merge" >
                            <span>{group.entries.length}</span>
                          </div>
                        )}

                        <Col
                          className={"cursor"}
                          onClick={() => {
                            // Don't initialize edit state if already in edit mode
                            if (group._id === editedId && group.entries.length === 1) {
                              return;
                            }
                            if (group.entries.length === 1) {
                              initializeEditState(group, false);
                            } else {
                              toggleGroup(groupIndex);
                            }
                          }}
                        >
                          {group._id === editedId && group.entries.length === 1 ? (
                            <input
                              type="text"
                              name="task"
                              value={taskNameEdit || ""}
                              onChange={(e) => setTaskNameEdit(e.target.value)}
                              // onClick={(e) => e.stopPropagation()}
                              // onMouseDown={(e) => e.stopPropagation()}
                              placeholder="Regular Input"
                              className={group._id === editedId && group.entries.length === 1 ? "input-edit-project" : "input-bg input-edit-project"}
                              style={{ textOverflow: "ellipsis" }}
                              autoComplete="off"
                            />
                          ) : group._id === editedId &&
                            group.entries.length > 1 ? (
                            <React.Fragment>
                              {group.task.length > 20 && (
                                <span className="tooltip-tracker testq">
                                  {group.task}
                                </span>
                              )}

                              <input
                                type="text"
                                name="task"
                                value={group.task || ""}
                                placeholder="Regular Input"
                                style={{ textOverflow: "ellipsis" }}
                                autoComplete="off"
                                readOnly
                              />
                            </React.Fragment>
                          ) : null}

                          {group._id !== editedId && (
                            <>
                              <MyComponentImportData group={group} editedId={editedId} />
                            </>
                          )}
                        </Col>
                      </div>

                      <div
                        className="project-sprint-outer col"
                        ref={projectEditDropdownRef}
                      >
                        {group._id === editedId && group.entries.length === 1 ? (
                          <>
                            <Col className="cursor 111 import-tracker-project"
                              onClick={handleProjectDropdownToggle}
                            >
                              {renderProjectNameDisplay(projectNameEdit, sprintNameEdit, clientEdit, projectIdEdit, true)}
                            </Col>
                            {renderProjectDropdown()}
                          </>
                        ) : group._id === editedId &&
                          group.entries.length > 1 ? (
                          <React.Fragment>
                            <Col
                              className={"cursor  import-tracker-project"}
                              onClick={() => {
                                if (group.entries.length === 1) {
                                  initializeEditState(group, false);
                                } else {
                                  toggleGroup(groupIndex);
                                }
                              }}
                            >
                              {renderProjectNameWithTooltip(
                                group.project?.project_name || "",
                                group.sprint?.sprint_name || "",
                                group.client || "",
                                "project-tracker-inner 11"
                              )}
                            </Col>
                          </React.Fragment>
                        ) : null}

                        {group._id !== editedId && (
                          <Col
                            className={"cursor import-tracker-project"}
                            onClick={() => {
                              if (group.entries.length === 1) {
                                initializeEditState(group, false);
                              } else {
                                toggleGroup(groupIndex);
                              }
                            }}
                          >
                            {renderProjectNameWithTooltip(
                              group.project?.project_name || "",
                              group.sprint?.sprint_name || "",
                              group.client || "",
                              "project-tracker-inner 11"
                            )}
                          </Col>
                        )}
                      </div>
                    </div>

                    <div className="outer-right-sec-overview">
                      <div className="overview-sec-timer-inner-right">
                        {/* Mobile view */}

                        <div
                          className="project-sprint-outer col project-sprint-outer-mobile"
                          style={{ display: "none" }}
                          ref={projectEditDropdownRef}
                        >
                          {group._id === editedId &&
                            group.entries.length === 1 ? (
                            <>
                              <Col
                                className="cursor"
                                onClick={handleProjectDropdownToggle}
                              >
                                {renderProjectNameDisplay(projectNameEdit, sprintNameEdit, clientEdit, projectIdEdit, true, "project-name-edit-inner", "140px")}
                              </Col>

                              {renderProjectDropdown()}
                            </>
                          ) : group._id === editedId &&
                            group.entries.length > 1 ? (
                            <React.Fragment>
                              <Col
                                className={"cursor import-tracker-project"}
                                onClick={() => {
                                  if (group.entries.length === 1) {
                                    initializeEditState(group, false);
                                  } else {
                                    toggleGroup(groupIndex);
                                  }
                                }}
                              >
                                {renderProjectNameWithTooltip(
                                  group.project?.project_name || "",
                                  group.sprint?.sprint_name || "",
                                  group.client || "",
                                  "project-tracker-inner",
                                  "140px"
                                )}
                              </Col>
                            </React.Fragment>
                          ) : null}

                          {group._id !== editedId && (
                            <Col
                              className={"cursor import-tracker-project"}
                              onClick={() => {
                                if (group.entries.length === 1) {
                                  initializeEditState(group, false);
                                } else {
                                  toggleGroup(groupIndex);
                                }
                              }}
                            >
                              {renderProjectNameWithTooltip(
                                group.project?.project_name || "",
                                group.sprint?.sprint_name || "",
                                group.client || "",
                                "project-tracker-inner",
                                "140px"
                              )}
                            </Col>
                          )}
                        </div>

                        {/* end mobile */}

                        {/* tag , timer section */}
                        <div className="tag-section-mobile-section">
                          <div className="tag-section-overview-outer dddd" ref={tagEditDropdownRef}>
                            {group._id === editedId &&
                              group.entries.length === 1 ? (
                              <div className="tag-section">
                                <p
                                  className={`cursor ${group.tag
                                    ? "tag-available"
                                    : "tag-not-available"
                                    }`}
                                  onClick={() => {
                                    setTagEditDropdownOpen(!tagEditDropdownOpen);
                                    setProjectEditDropdownOpen(false);
                                  }}
                                >
                                  <span className="tooltip-tracker">
                                    {" "}
                                    {renderTagIconOrName(group.tag?.tag_name, tagEdit)}
                                  </span>
                                  <span
                                    className="tag-edit-tag-name"
                                    style={{
                                      display: "inline-block",
                                      maxWidth: "180px",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {" "}
                                    {renderTagIconOrName(group.tag?.tag_name, tagEdit)}
                                  </span>
                                </p>
                                {renderTagDropdown()}
                              </div>
                            ) : group._id === editedId &&
                              group.entries.length > 1 ? (
                              <React.Fragment>
                                <div
                                  className="tag-section"
                                  onClick={() => {
                                    if (group.entries.length === 1) {
                                      initializeEditState(group, false);
                                    } else {
                                      toggleGroup(groupIndex);
                                    }
                                  }}
                                >
                                  <p
                                    className={`cursor ${group.tag
                                      ? "tag-available"
                                      : "tag-not-available"
                                      }`}
                                    onClick={() => {
                                      if (group.entries.length === 1) {
                                        initializeEditState(group, false);
                                      } else {
                                        toggleGroup(groupIndex);
                                      }
                                    }}
                                  >
                                    <span className="tooltip-tracker">
                                      {" "}
                                      {renderTagIconOrName(group.tag?.tag_name)}
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {" "}
                                      {renderTagIconOrName(group.tag?.tag_name)}
                                    </span>
                                  </p>
                                </div>
                              </React.Fragment>
                            ) : null}

                            {group._id !== editedId && (
                              <div
                                className="tag-section"
                                onClick={() => {
                                  if (group.entries.length === 1) {
                                    initializeEditState(group, false);
                                  } else {
                                    toggleGroup(groupIndex);
                                  }
                                }}
                              >
                                <p
                                  className={`cursor ${group.tag ? "tag-available" : "tag-not-available"}`}
                                  onClick={() => {
                                    if (group.entries.length === 1) {
                                      initializeEditState(group, false);
                                    } else {
                                      toggleGroup(groupIndex);
                                    }
                                  }}
                                >
                                  <span className="tooltip-tracker">
                                    {" "}
                                    {renderTagIconOrName(group.tag?.tag_name)}
                                  </span>
                                  <span
                                    style={{
                                      display: "inline-block",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {" "}
                                    {renderTagIconOrName(group.tag?.tag_name)}
                                  </span>
                                </p>
                              </div>
                            )}
                            <input
                              type="hidden"
                              name="tag"
                              value={tagIdEdit || ""}
                            />
                          </div>

                          <div className="billable-section">
                            {renderBillableIcon(editedId === group._id ? billableEdit : group.billable)}
                          </div>
                          <div
                            className={`overview-sec-timer-date-time date-${group._id}`}
                            style={{ position: "relative" }}
                          >
                            <Col>
                              {group._id === editedId &&
                                group.entries.length === 1 ? (
                                <>
                                  <div className="time-overview-sec">
                                    {renderTimeInputs(
                                      timeFormat === 24 ? startTimeEdit24 : startTimeEdit,
                                      timeFormat === 24 ? endTimeEdit24 : endTimeEdit,
                                      timeFormat === 24,
                                      false,
                                      timeFormat === 24
                                        ? (e) => {
                                          if (validateNoAlphabets(e.target.value)) {
                                            setStartTimeEdit24(e.target.value);
                                          }
                                        }
                                        : (e) => setStartTimeEdit(e.target.value),
                                      timeFormat === 24
                                        ? (e) => {
                                          if (validateNoAlphabets(e.target.value)) {
                                            setEndTimeEdit24(e.target.value);
                                          }
                                        }
                                        : (e) => setEndTimeEdit(e.target.value),
                                      timeFormat === 24
                                        ? () => {
                                          if (!startTimeEdit) setStartTimeEdit("7:46pm");
                                          setIsTimeInputActive(false);
                                        }
                                        : () => {
                                          if (!startTimeEdit) setStartTimeEdit("07:46 PM");
                                          setIsTimeInputActive(false);
                                        },
                                      timeFormat === 24
                                        ? () => {
                                          if (!endTimeEdit) setEndTimeEdit("8:50pm");
                                          setIsTimeInputActive(false);
                                        }
                                        : () => {
                                          if (!endTimeEdit) setEndTimeEdit("08:50 PM");
                                          setIsTimeInputActive(false);
                                        },
                                      () => setIsTimeInputActive(true),
                                      () => setIsTimeInputActive(true),
                                      uStartTimeError,
                                      uEndTimeError
                                    )}
                                  </div>
                                  <div className="date-overview-sec date-overview-edit">
                                    <div
                                      onClick={handleDateIconClick}
                                      className="custom-date-icon"
                                    >
                                      <DatePickerIconSVG />
                                    </div>
                                    <DatePicker
                                      block
                                      name="date"
                                      appearance="subtle"
                                      value={
                                        new Date(
                                          zoneConverter(
                                            dateEdit,
                                            global.config.getTimeZone(),
                                            "YYYY-MM-DD HH:mm:ss"
                                          )
                                        )
                                      }
                                      onChange={(value) => {
                                        setDateOldEdit(
                                          new Date(
                                            zoneConverter(
                                              dateEdit,
                                              global.config.getTimeZone(),
                                              "YYYY-MM-DD HH:mm:ss"
                                            )
                                          )
                                        );
                                        setDateEdit(value);
                                      }}
                                      ref={datePickerRef}
                                      placement="bottomEnd"
                                      oneTap
                                      isoWeek={
                                        appSettings.weekStartDay &&
                                        appSettings.weekStartDay === "Monday"
                                      }
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div
                                    className="time-overview-sec"
                                    onClick={() => {
                                      if (group.entries.length === 1) {
                                        initializeEditState(group, false, true);
                                      } else {
                                        toggleGroup(groupIndex);
                                      }
                                    }}
                                  >
                                    {renderReadOnlyTimeInputs(group.startTime, group.endTime, timeFormat === 24)}
                                  </div>
                                  <div
                                    className="date-overview-sec"
                                    onClick={() => {
                                      if (group.entries.length === 1) {
                                        initializeEditState(group, false);
                                      } else {
                                        toggleGroup(groupIndex);
                                      }
                                    }}
                                  >
                                    <div
                                      className="custom-date-icon"
                                      style={pointerCursorStyle}
                                    >
                                      <DatePickerIconSVG />
                                    </div>
                                  </div>
                                </>
                              )}
                            </Col>
                          </div>

                          <div className="overview-time-edit">
                            <Col>
                              <div className="overview-time-edit-inner">
                                {/* duration edit section */}
                                {group._id === editedId &&
                                  group.entries.length === 1 ? (
                                  <div
                                    className="timer-sec-input"
                                    style={{
                                      backgroundColor:
                                        uFormatedTimeError && "#fddada",
                                    }}
                                  >
                                    <input
                                      className={
                                        group._id === editedId &&
                                          group.entries.length === 1
                                          ? "edit-time"
                                          : "edit-time"
                                      }
                                      name="time"
                                      value={uFormatedTime ?? ""}
                                      onChange={(e) => {
                                        // handleTimeChange
                                        timeShowEdit(e.target.value);
                                      }}
                                      placeholder="00:00:00"
                                      type="text"
                                      autoComplete="off"
                                    />
                                  </div>
                                ) : group._id === editedId &&
                                  group.entries.length > 1 ? (
                                  <React.Fragment>
                                    <div
                                      className="timer-sec-input"
                                      onClick={() => {
                                        if (group.entries.length === 1) {
                                          initializeEditState(group, false);
                                        } else {
                                          toggleGroup(groupIndex);
                                        }
                                      }}
                                    >
                                      <input
                                        style={{ cursor: "pointer" }}
                                        className={group._id === editedId && group.entries.length === 1 ? "before-edit-input" : "before-edit-input"}
                                        name="time"
                                        value={formatDuration(group.totalDuration)}
                                        placeholder="00:00:00"
                                        type="text"
                                        autoComplete="off"
                                        readOnly
                                      />
                                    </div>
                                  </React.Fragment>
                                ) : null}

                                {/* duration edit section end */}

                                {group._id !== editedId && (
                                  <div
                                    className="timer-sec-input"
                                    onClick={() => {
                                      if (group.entries.length === 1) {
                                        initializeEditState(group, false);
                                      } else {
                                        toggleGroup(groupIndex);
                                      }
                                    }}
                                  >
                                    <input
                                      style={{ cursor: "pointer" }}
                                      className={
                                        group._id === editedId &&
                                          group.entries.length === 1
                                          ? "before-edit-input"
                                          : "before-edit-input"
                                      }
                                      name="time"
                                      value={formatDuration(group.totalDuration)}
                                      placeholder="00:00:00"
                                      type="text"
                                      autoComplete="off"
                                      readOnly
                                    />
                                  </div>
                                )}
                              </div>

                              {group._id === editedId &&
                                group.entries.length === 1 ? (
                                <div className="set-btn-outer">
                                  {!isTimeInputActive && (
                                    <button
                                      type="submit"
                                      className="set-button"
                                      disabled={
                                        (isUpdateLoading ||
                                          uFormatedTimeError ||
                                          uEndTimeError ||
                                          uStartTimeError ||
                                          isTimeInputActive) &&
                                        "disabled"
                                      }
                                    >
                                      {isUpdateLoading ? (
                                        <div
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                                            borderRadius: "4px",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          width="18"
                                          src={Update}
                                          alt="update"
                                        />
                                      )}
                                    </button>
                                  )}
                                </div>
                              ) : null}

                              {group._id !== editedId &&
                                group.entries.length < 2 && (
                                  <>
                                    {renderCheckbox(group._id)}
                                  </>
                                )}
                            </Col>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {expandedGroups.includes(groupIndex) &&
                    group.entries.length > 1 &&
                    group.entries.map((row, index) => (
                      <div
                        className={`merge-tracker merge-tracker-iner ${row._id === editedId ? "editer" : ""}`}
                        style={{
                          backgroundColor:
                            row._id === editedId ? "#f0f7f9" : (invalidEntryIds.has(row._id) ? "#fff9f9" : "#fff"),
                          padding: row._id === editedId ? "10px" : "",
                          border: row._id === editedId ? "" : (invalidEntryIds.has(row._id) ? "1px solid red" : ""),
                        }}
                        onClick={() => { }}
                      >
                        <div className="overview-sec-timer-inner">
                          <div className="project-name">
                            <div
                              class="count-merge"
                              style={{ cursor: "pointer" }}
                            >
                              <span></span>
                            </div>
                            <Col
                              className={"cursor import-tracker-project"}
                              onClick={() => {
                                // Don't initialize edit state if already in edit mode
                                if (row._id === editedId) {
                                  return;
                                }
                                initializeEditState(row, true);
                              }}
                            >
                              {row._id === editedId && (
                                <input
                                  type="text"
                                  name="task"
                                  value={taskNameEdit || ""}
                                  onChange={(e) =>
                                    setTaskNameEdit(e.target.value)
                                  }
                                  // onClick={(e) => e.stopPropagation()}
                                  // onMouseDown={(e) => e.stopPropagation()}
                                  placeholder="Regular Input"
                                  className={
                                    row._id === editedId
                                      ? "input-edit-project"
                                      : "input-bg input-edit-project"
                                  }
                                  style={{ textOverflow: "ellipsis" }}
                                  autoComplete="off"
                                />
                              )}

                              {row._id !== editedId && (
                                <>
                                  {/* </span> */}
                                  <MyComponentImportData
                                    group={row}
                                    editedId={editedId}
                                  />
                                </>
                              )}
                            </Col>
                          </div>

                          <div
                            className="project-sprint-outer col 111"
                            ref={projectEditDropdownRef}
                          >
                            {row._id === editedId && (
                              <>
                                <Col
                                  className="cursor"
                                  onClick={() => {
                                    setProjectEditDropdownOpen(!projectEditDropdownOpen);
                                    setFilter("");
                                    setSelectedClients(new Set());
                                    setSelectedProject(null);
                                    setTagEditDropdownOpen(false);
                                  }}
                                >
                                  <span
                                  // className={`tooltip-tracker ${currentTextCount(
                                  //   projectNameEdit,
                                  //   sprintNameEdit && sprintNameEdit,
                                  //   clientEdit && clientEdit
                                  // ) < 21
                                  //   ? "small"
                                  //   : "large"
                                  //   }`}
                                  >
                                    {renderProjectNameDisplay(projectNameEdit, sprintNameEdit, clientEdit, projectIdEdit, true, "project-tracker-inner")}
                                  </span>
                                </Col>
                                {renderProjectDropdown()}
                              </>
                            )}

                            {row._id !== editedId && (
                              <Col
                                className={"cursor import-tracker-project"}
                                onClick={() => {
                                  initializeEditState(row, true);
                                }}
                              >
                                {renderProjectNameWithTooltip(
                                  row.project?.project_name || "",
                                  row.sprint?.sprint_name || "",
                                  row.client || ""
                                )}
                              </Col>
                            )}
                          </div>
                        </div>

                        <div className="outer-right-sec-overview">
                          <div className="overview-sec-timer-inner-right">
                            {/* Mobile view */}
                            <div
                              className="project-sprint-outer col project-sprint-outer-mobile"
                              style={{ display: "none" }}
                              ref={projectEditDropdownRef}
                            >
                              {row._id === editedId && (
                                <>
                                  <Col
                                    className="cursor"
                                    onClick={handleProjectDropdownToggle}
                                  >
                                    {renderProjectNameDisplay(projectNameEdit, sprintNameEdit, clientEdit, projectIdEdit, true, "project-name-edit-inner", "140px")}
                                  </Col>
                                  {renderProjectDropdown()}
                                </>
                              )}

                              {row._id !== editedId && (
                                <Col
                                  className={"cursor import-tracker-project"}
                                  onClick={() => {
                                    initializeEditState(row, true);
                                  }}
                                >
                                  {renderProjectNameDisplay(
                                    row.project?.project_name || "",
                                    row.sprint?.sprint_name || "",
                                    row.client || "",
                                    row.project?._id || null,
                                    false,
                                    "project-tracker-inner",
                                    "140px"
                                  )}
                                </Col>
                              )}
                            </div>

                            {/* end mobile */}

                            {/* tag , timer section */}
                            <div className="tag-section-overview-outer" ref={tagEditDropdownRef}>
                              {row._id === editedId && (
                                <div className="tag-section">
                                  <p
                                    className={`cursor ${row.tag ? "tag-available" : "tag-not-available"}`}
                                    onClick={() => {
                                      setTagEditDropdownOpen(!tagEditDropdownOpen);
                                      setProjectEditDropdownOpen(false);
                                    }}
                                  >
                                    <span className="tooltip-tracker">
                                      {" "}
                                      {renderTagIconOrName(row.tag?.tag_name, tagEdit)}
                                    </span>
                                    <span
                                      className="tag-edit-tag-name"
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "180px", // Define a maxWidth or width based on your layout
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {" "} {renderTagIconOrName(row.tag?.tag_name, tagEdit)}
                                    </span>
                                  </p>
                                  {tagEditDropdownOpen && (
                                    <div className="custom-dropdown">
                                      <input
                                        type="text"
                                        className="search-bar"
                                        placeholder="Search..."
                                        value={tagEdit || ""}
                                        onChange={handleTagInputChange}
                                        autoComplete="off"
                                        disabled={isLoadingTagDetails}
                                      />
                                      <ul className="client-list">
                                        {isLoadingTagDetails ? (
                                          <>
                                            {Array.from({ length: 3 }).map((_, index) => (
                                              <li
                                                key={`skeleton-tag-row-${index}`}
                                                className="cursor"
                                                style={{ pointerEvents: "none", cursor: "default" }}
                                              >
                                                <div
                                                  style={{
                                                    width: "120px",
                                                    height: "20px",
                                                    backgroundColor: "#e5e7eb",
                                                    borderRadius: "4px",
                                                    animation: "pulse 1.5s ease-in-out infinite",
                                                  }}
                                                />
                                              </li>
                                            ))}
                                          </>
                                        ) : (
                                          filteredTagItems.map((row) => (
                                            <li
                                              className="cursor"
                                              key={row._id}
                                              onClick={(e) => {
                                                setTagEdit(row.tag_name);
                                                setTagIdEdit(row._id);
                                                setTagEditDropdownOpen(false);
                                              }}
                                            >
                                              {row.tag_name}
                                            </li>
                                          ))
                                        )}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              )}
                              {row._id !== editedId && (
                                <div
                                  className="tag-section"
                                  onClick={() => {
                                    initializeEditState(row, true);
                                  }}
                                >
                                  <p
                                    className={`cursor ${row.tag ? "tag-available" : "tag-not-available"}`}
                                    onClick={() => {
                                      initializeEditState(row, true);
                                    }}
                                  >
                                    <span className="tooltip-tracker">
                                      {" "}
                                      {renderTagIconOrName(row.tag?.tag_name)}
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {" "}
                                      {renderTagIconOrName(row.tag?.tag_name)}
                                    </span>
                                  </p>
                                </div>
                              )}
                              <input type="hidden" name="tag" value={tagIdEdit || ""} />
                            </div>
                            <div className="billable-section">
                              {renderBillableIcon(editedId === row._id ? billableEdit : row.billable)}
                            </div>
                            <div className={`overview-sec-timer-date-time date-${row._id}`} style={{ position: "relative" }} >
                              <Col>
                                {row._id === editedId ? (
                                  <>
                                    <div className="time-overview-sec">
                                      {renderTimeInputs(
                                        timeFormat === 24 ? startTimeEdit24 : startTimeEdit,
                                        timeFormat === 24 ? endTimeEdit24 : endTimeEdit,
                                        timeFormat === 24,
                                        true,
                                        timeFormat === 24
                                          ? (e) => {
                                            if (validateNoAlphabets(e.target.value)) {
                                              setStartTimeEdit24(e.target.value);
                                            }
                                          }
                                          : (e) => setStartTimeEdit(e.target.value),
                                        timeFormat === 24
                                          ? (e) => {
                                            if (validateNoAlphabets(e.target.value)) {
                                              setEndTimeEdit24(e.target.value);
                                            }
                                          }
                                          : (e) => setEndTimeEdit(e.target.value),
                                        timeFormat === 24
                                          ? () => {
                                            if (!startTimeEdit) setStartTimeEdit("7:46pm");
                                            setIsTimeInputActive(false);
                                          }
                                          : () => {
                                            if (!startTimeEdit) setStartTimeEdit("07:46 PM");
                                            setIsTimeInputActive(false);
                                          },
                                        timeFormat === 24
                                          ? () => {
                                            if (!endTimeEdit) setEndTimeEdit("8:50pm");
                                            setIsTimeInputActive(false);
                                          }
                                          : () => {
                                            if (!endTimeEdit) setEndTimeEdit("08:50 PM");
                                            setIsTimeInputActive(false);
                                          },
                                        () => setIsTimeInputActive(true),
                                        () => setIsTimeInputActive(true),
                                        uStartTimeError,
                                        uEndTimeError
                                      )}
                                    </div>

                                    <div className="date-overview-sec date-overview-edit">
                                      <div onClick={handleDateIconClick} className="custom-date-icon">
                                        <DatePickerIconSVG />
                                      </div>
                                      <DatePicker
                                        block
                                        name="date"
                                        appearance="subtle"
                                        value={
                                          new Date(zoneConverter(dateEdit, global.config.getTimeZone(), "YYYY-MM-DD HH:mm:ss"))
                                        }
                                        onChange={(value) => {
                                          setDateOldEdit(new Date(zoneConverter(dateEdit, global.config.getTimeZone(), "YYYY-MM-DD HH:mm:ss")));
                                          setDateEdit(value);
                                        }}
                                        ref={datePickerRef}
                                        placement="bottomEnd"
                                        oneTap
                                        isoWeek={appSettings.weekStartDay && appSettings.weekStartDay === "Monday"}
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div
                                      className="time-overview-sec"
                                      onClick={() => {
                                        initializeEditState(row, true, true);
                                      }}
                                    >
                                      {renderReadOnlyTimeInputs(row.startTime, row.endTime, timeFormat === 24)}
                                    </div>
                                    <div
                                      className="date-overview-sec"
                                      onClick={() => {
                                        initializeEditState(row, true);
                                      }}
                                    >
                                      <div className="custom-date-icon" style={pointerCursorStyle}>
                                        <DatePickerIconSVG />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </Col>
                            </div>

                            <div className="overview-time-edit">
                              <Col>
                                <div className="overview-time-edit-inner">
                                  {/* duration edit section */}
                                  {row._id === editedId && (
                                    <>
                                      <div className="timer-sec-input" style={{ backgroundColor: uFormatedTimeError && "#fddada", }} >
                                        <input
                                          className={row._id === editedId ? "edit-time" : "edit-time"}
                                          name="time"
                                          value={uFormatedTime ?? ""}
                                          onChange={(e) => { timeShowEdit(e.target.value); }}
                                          placeholder="00:00:00"
                                          type="text"
                                          autoComplete="off"
                                        />
                                      </div>
                                    </>
                                  )}

                                  {/* duration edit section end */}

                                  {row._id !== editedId && (
                                    <div
                                      className="timer-sec-input"
                                      onClick={() => {
                                        initializeEditState(row, true);
                                      }}
                                    >
                                      <input
                                        style={{ cursor: "pointer" }}
                                        className={row._id === editedId ? "before-edit-input" : "before-edit-input"}
                                        name="time"
                                        // value={`${formatTime(row.hr)}:${formatTime(row.min)}:${formatTime(row.sec)}`}
                                        value={formatDuration(row.duration)}
                                        placeholder="00:00:00"
                                        type="text"
                                        autoComplete="off"
                                        readOnly
                                      />
                                    </div>
                                  )}
                                </div>

                                {row._id === editedId && (
                                  <div className="set-btn-outer">
                                    {!isTimeInputActive && (
                                      <button
                                        type="submit"
                                        className="set-button"
                                        disabled={
                                          (isUpdateLoading ||
                                            uFormatedTimeError ||
                                            uEndTimeError ||
                                            uStartTimeError ||
                                            isTimeInputActive) &&
                                          "disabled"
                                        }
                                      >
                                        {isUpdateLoading ? (
                                          <div
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              backgroundColor: "rgba(255, 255, 255, 0.5)",
                                              borderRadius: "4px",
                                              animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                          />
                                        ) : (
                                          <img width="18" src={Update} alt="update" />
                                        )}
                                      </button>
                                    )}
                                  </div>
                                )}

                                {row._id !== editedId && (
                                  <>
                                    {renderCheckbox(row._id)}
                                  </>
                                )}
                              </Col>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </form>
            </React.Fragment>
          ))}
      </>
      {/* Pulse animation style */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </Card.Body>
  );
};

export default CardBodyImportDataCalendar;
